import { StoreResult } from '@/store/CertificateStore';
import { AbstractSignatureStrategy } from './AbstractSignatureStrategy';
import Dictionary from '@/types/Dictionary';
import { Resource, SMACertificate } from '@/types/Administration/SMA/SMACertificate';

export class SupervisorSignature extends AbstractSignatureStrategy {

    /**
     * Demande de validation par mot de passe
     */
    public readonly requiresPasswordValidation = true;

    /**
     * Récupération du mandat format base
     * @param param0 item : certificat, resource : ressources
     * @returns Liste de blobs
     */
    public override async execute({ item: certificate, resource: resources }: { item: SMACertificate; resource: Resource[] }): Promise<StoreResult<Blob>> {
        let response: any = null;

        try {
            response = await this.store.dispatch("CertificateStore/Download", { item: certificate, resources: resources });
            return response;
        } catch (error) {
            return response;
        }
    }

    /**
     * Submit de la signature superviseur
     * @param parameters 
     */
    public override async validation(parameters: Dictionary<any>): Promise<StoreResult<Blob>> {
        return await this.store.dispatch("CertificateStore/SupervisorValidation", { 
            Certificate: parameters.Certificate,
            Password: parameters.Password
        });
    }
}